var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bet-panel-container",
      style: {
        transform: "scale(" + _vm.scaleRatio + ")",
        "max-height": _vm.maxHeight,
      },
    },
    [
      _c("BettingZone"),
      _vm._t("under-zone"),
      _vm.showStatus && (!_vm.isMobile || _vm.isMobileLandscape)
        ? _c("GameStatus", {
            attrs: { active: _vm.active },
            on: {
              jackpotCollectPopup: function ($event) {
                return _vm.$emit("jackpotCollectPopup")
              },
              jackpotPhysicalPopup: function ($event) {
                return _vm.$emit("jackpotPhysicalPopup")
              },
            },
          })
        : _vm._e(),
      _c("FunctionBtns"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }